<template>
  <div class="card-wrapper" v-if="imageUrl">
    <img
      :src="imageUrl.includes('http') ? imageUrl : require(`../../assets/images/card-images/${imageUrl}`)"
      alt="this is card image"
      class="card-image"
    />
    <div
      class="card-content title3"
      :style="{ color: colorStyle, fontSize: contentSize + 'px' }"
    >
      {{ cardContent }}
    </div>
    <div
      v-if="variant === 'normal'"
      class="card-value title3"
      :style="{ color: colorStyle }"
    >
      ${{ cardValue }}.00
    </div>
  </div>
</template>

<script lang="ts">

export default ({
  props: {
    imageUrl: {
      required: true,
      type: String,
    },
    cardContent: {
      required: true,
      type: String,
    },
    cardValue: {
      type: Number,
    },
    colorStyle: {
      required: true,
      type: String,
    },
    variant: {
      type: String,
    },
    contentSize: {
      type: Number,
    },
  },
});
</script>

<style scoped>
.card-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 5%;
}
.card-content {
  color: #ffffff;
  position: absolute;
  width: 80%;
  text-align: center;
  top: 54%;
  transform: translate(-50%, -50%);
  left: 50%;
  overflow-wrap: break-word;
  overflow: auto;
}
.card-value {
  color: #ffffff;
  position: absolute;
  top: 0.5rem;
  right: 1rem;
}
.card-wrapper {
  position: relative;
  /* width: 100%; */
  height: 100%;
}
.carousel__nav .card-wrapper {
  cursor: pointer;
}

/* @media only screen and (max-width: 600px) {
  .card-wrapper {
    width: 260px;
    margin: 0 auto;
  }
} */
</style>
